import React from "react";
import logo from "@images/MULTICOTIZADOR LOGO.svg"
import issfam from "@images/issfam-img.png"
import './Navbar.css';
import {Link, useLocation} from "react-router-dom";

export default function Navbar() {

    const isAuthenticated = localStorage.getItem("isAuthenticated");
    let location = useLocation();

    return (
        location.pathname === '/login' ? null :
        <nav className="navbar navbar-inverse navbar-dark bg-skrPrimary w-auto border-skrPrimary" style={{'box-shadow': '0px 2px 4px #00000040'}}>
            <div className="container-fluid">
                <div className="navbar-header mx-5 my-3">                    
                    <img src={logo} className="img-logo-nav" alt="logoSekura"/>
                    <img src={issfam} className="mx-5 img-logo-issfam" alt="logoIssfam"/>                
                </div>
                <ul className="nav navbar-nav navbar-right mx-5">
                    {location.pathname === '/cotizador' || location.pathname === '/login' ?
                        <li>
                            <Link to="/login">
                                <button className="btn btn-skr-secondary"><i className="fs-6 bi-box-arrow-right"></i> Acceder
                                </button>
                            </Link>
                        </li> : null}
                </ul>
            </div>
        </nav>

    );
}